import React from 'react';
import {useTranslation} from 'react-i18next';
import {WideHeader} from '../../layout/wide';

const About: React.FC = () => {
  const {t} = useTranslation();
  return (
    <>
      <WideHeader
        title={t('about.title')}
        introduction={t('about.introduction')}
        narrow={true}
      />

      <section className="bg-gray-100 py-8">
        <div className="container mx-auto px-4 max-w-4xl">
          <h2 className="text-2xl font-cinzel font-bold text-gray-900 mb-4">{t('about.cvpTitle')}</h2>

          <div className="space-y-4 text-gray-700 leading-relaxed">
            <p>
              {t('about.cvpHistory1')}
            </p>

            <p>
              {t('about.cvpHistory2')}
            </p>

            <p>
              {t('about.cvpHistory3')}
            </p>
          </div>

          <div className="mt-12">
            <h2 className="text-2xl font-cinzel font-bold text-gray-900 mb-6">{t('about.committeeTitle')}</h2>

            <h3 className="text-lg font-semibold text-gray-800 mb-4">{t('about.committeeMembersTitle')}</h3>

            <ul className="space-y-2 text-gray-700">
              <li>prof. dr hab. Wojciech Bałus ({t('about.roles.president')})</li>
              <li>dr Edyta Bernady</li>
              <li>Beata Fekecz-Tomaszewska</li>
              <li>Elżbieta Gajewska-Prorok</li>
              <li>dr Dobrosława Horzela</li>
              <li>dr Marta Kamińska ({t('about.roles.treasurer')})</li>
              <li>dr Magda Ławicka</li>
              <li>Sławomir Oleszczuk</li>
              <li>dr Tomasz Szybisty ({t('about.roles.secretary')})</li>
              <li>dr Joanna Utzig</li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
